import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Project } from 'services/action';

import { Page, Button } from 'ui/components';

import { FormInput } from './component/form';

const initialState = {
  ready: false,
  data: null,
  form: null,
};

const UpdateScreen = ({ match }) => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);

  const [{ ready, data, form }, setState] =
    React.useState(initialState);

  const $handleFormChange = (v) => {
    setState((prevState) => ({ ...prevState, form: v }));
  };


  const $handleSubmit = async () => {
    const payload = {
      ...form,
    };

    const submit = await Dispatch(Project.$update(data?.id, payload));

    if (submit?.message === 'success') {
      History.replace(`/master/project`);
    }
  };

  React.useEffect(() => {
    const $onLoad = async (id) => {
      const req = await Dispatch(Project.$show(id));

      if (req?.message === 'success' && req?.data !== null) {
        setState((prevState) => ({
          ...prevState,
          data: req?.data,
          ready: true,
        }));
      }
    };

    if (!ready) $onLoad(match?.params?.id);
  }, []);

  return (
    <Page type="form" className="bg-white" onSubmit={$handleSubmit}>
      <Page.Header title="Perbaharui Project" />

      <Page.Body className="d-block row px-3">
        <FormInput data={data} onInputChange={$handleFormChange} />
      </Page.Body>
      <Page.Footer className="justify-content-center gap-2 pt-3 border-top mt-5 d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/master/project`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default UpdateScreen;
